// @flow
import type { Game, GameWithTimeStamp } from "../common/types";
import _ from "lodash";

// cache for performance
const today = new Date();

const datesAreOnSameDay = (first, second) =>
  first.getFullYear() === second.getFullYear() &&
  first.getMonth() === second.getMonth() &&
  first.getDate() === second.getDate();

const getGamesFilteredByTeam: [Game] = (games: [Game], filter) => {
  if (filter != null && filter.length > 0) {
    return games.filter((game) => {
      return filter.includes(game.teamId);
    });
  }
  return [];
};

const getGamesFilteredByType: [Game] = (games: [Game], filter) => {
  if (filter === "HOMEGAMES") {
    return games.filter((game) => game.isHomegame);
  }
  if (filter === "GUESTGAMES") {
    return games.filter((game) => !game.isHomegame);
  }
  return games;
};

const getGamesWithTimestamp: [GameWithTimeStamp] = (games: [Game]) => {
  return games.map((game: Game) => ({
    ...game,
    dateStamp: new Date(game.date),
  }));
};

const getUpcomingGames: [GameWithTimeStamp] = (games: [GameWithTimeStamp]) => {
  return games.filter((game) => {
    const { dateStamp } = game;
    return (
      dateStamp.getTime() - today.getTime() >= 0 &&
      !datesAreOnSameDay(dateStamp, today)
    );
  });
};

const getTodaysGames: [GameWithTimeStamp] = (games: [GameWithTimeStamp]) => {
  return games.filter((game) => datesAreOnSameDay(today, game.dateStamp));
};

const getPastGames: [GameWithTimeStamp] = (games: [GameWithTimeStamp]) => {
  const gamesFiltered = games.filter((game) => {
    const { dateStamp } = game;
    return (
      dateStamp.getTime() - today.getTime() < 0 &&
      !datesAreOnSameDay(dateStamp, today)
    );
  });
  return _.orderBy(gamesFiltered, ["date"], ["desc"]);
};

const getLeftAndRightTeams = (game, team, opponent) => {
  const leftTeam = game.isHomegame ? team : opponent;
  const rightTeam = game.isHomegame ? opponent : team;
  return { leftTeam, rightTeam };
};

const gameSelectors = {
  getGamesFilteredByTeam,
  getGamesFilteredByType,
  getGamesWithTimestamp,
  getUpcomingGames,
  getTodaysGames,
  getPastGames,
  getLeftAndRightTeams,
};

export default gameSelectors;
